// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"e4ba3119","184":"3c3e653b","274":"2ed1eb7c","303":"14097632","397":"7d0db405","453":"dc6b95f6","517":"89e66b8f","653":"3478c506","676":"57b7f5b0","797":"1ea06119","803":"f5c1c5a7","986":"2354adb7"}[chunkId] + ".chunk.js";
};